export const ERRORS = {
  ERR_NETWORK: 'ERR_NETWORK',
  SPOTTY_CONNECTION_ERR_NETWORK: 'SPOTTY_CONNECTION_ERR_NETWORK',
  GMA_UNREACHABLE_ERR_NETWORK: 'GMA_UNREACHABLE_ERR_NETWORK'
};